/*
 * Deprecating this functionality and no new functionality should be added to this file.
 * This file makes no sense, it's doing too many things.
 * TODO: Put these functionalities with their related files if needed, else delete them.
 */

import _ from 'underscore';
import $ from 'jquery';
import Paths from '../signup/util/paths.js';
import boUrl from '../twig/helpers/boUrl';

const helpers = {
  youtubeModal() {
    /**
     *
     * Uses Bootstraped modal element and data-the-video attrib
     * to pop open autoplaying modal.
     *
     * TODO -- Update data-attrib to something less fugly
     * TODO -- Remove bootstrapped modal (though this will work fine without it)
     *
     */
    const trigger = $('a.video-link');

    if (!trigger.length) return;

    // eslint-disable-next-line func-names
    trigger.click(function() {
      const theModal = $(this).data('target');
      const videoSRC = $(this).attr('data-the-video');
      const videoSRCauto = `${videoSRC}?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=1`;
      $(`${theModal} iframe`).attr('src', videoSRCauto);
      $('.modal').click(() => {
        $(`${theModal} iframe`).attr(
          'src',
          `${videoSRC}?rel=0&amp;controls=1&amp;showinfo=0&amp;autoplay=0`
        );
      });
    });
  },

  analyticsPixels() {
    // Load pixels , for inline frames
    window.addPixel = (selectedPixels) => {
      // Avaialble lead pixels
      const pixels = {
        BingLead: 'https://bat.bing.com/action/0?ti=4039915&Ver=2',
        FacebookLead:
          'https://www.facebook.com/tr?ev=6024845019506&amp;cd[value]=0.00&amp;cd[currency]=USD&amp;noscript=1',
        GoogleLeadUS:
          'https://www.googleadservices.com/pagead/conversion/1004055769/?label=pUKtCN_Fo1oQ2dni3gM&amp;guid=ON&amp;script=0',
        GoogleLeadUK:
          'https://www.googleadservices.com/pagead/conversion/948946956/?label=N4ThCPPXilwQjJC_xAM&amp;guid=ON&amp;script=0'
      };

      _.each(selectedPixels, (value) => {
        $('body').append(
          $('<img>', { style: 'display:none', src: pixels[value] })
        );
      });
    };
  },

  calcDeadline() {
    // Return how many days left until a provided date
    window.skCalcDeadline = (endDate) => {
      const today = new Date();
      const deadLine = new Date(endDate);
      const msPerDay = 24 * 60 * 60 * 1000;
      const timeLeft = deadLine.getTime() - today.getTime();
      const eDaysLeft = timeLeft / msPerDay;
      const daysLeft = Math.floor(eDaysLeft);
      return daysLeft;
    };
  },

  backOffice() {
    // Setup Backoffice URL
    boUrl.init();

    window.loginRedirect = (exists, subdomain, root) => {
      if (exists) {
        window.location = [
          root.slice(0, 8),
          `${subdomain}.`,
          root.slice(8)
        ].join('');
      } else {
        $('#login_loader').hide();
        $('#store_name').addClass('error');
        $('#store_name_error')
          .html(
            '<p>Store name does not exist. Please check your spelling and try again.</p>'
          )
          .fadeIn(200);
      }
    };

    // eslint-disable-next-line func-names
    window.loginBackoffice = function(evt) {
      evt.preventDefault();

      const subdomainInput = $('input[name=storename]', this);
      const subdomain = $(subdomainInput).val();

      if (subdomain.length > 0 && subdomain.match(/^[A-Za-z0-9-]+$/)) {
        $.ajax({
          url: `${Paths.root}/ajax/is-subdomain-available/${subdomain}?callback=?`,
          dataType: 'json',
          error() {
            window.wiggleElem(subdomainInput);
          },
          success(_arg) {
            if (_arg.available === false) {
              window.loginRedirect(!_arg.available, subdomain, boUrl.url());
            } else {
              window.wiggleElem(subdomainInput);
            }
          }
        });
      } else {
        window.wiggleElem(subdomainInput);
      }
    };
  }
};

helpers.analyticsPixels();
helpers.calcDeadline();
helpers.backOffice();

export default helpers;
